import React from 'react';
import { Eye } from 'react-feather';
import { useDispatch } from 'react-redux';
import { stackAside } from '../../state/component/AsideSlice';
import { TruncateString } from '../../utils/text/TruncateString';
import Table from '../tables/Table';
import TableItem from '../tables/TableItem';
import TableRow from '../tables/TableRow';
import Tag from '../tags/Tag';
import DateFormatted from '../typography/Date';
import Typography from '../typography/Typography';

type Props = {
  tickets: object[];
  callback?: (e: any) => void;
};

export const TicketTable = ({ tickets, callback }: Props) => {
  const dispatch = useDispatch();

  const viewTicket = async (ticket: any) => {
    dispatch(
      stackAside({
        component: 'ticket',
        data: { ticket: ticket },
        title: `Ticket`,
      })
    );
  };

  const tableHeaders: object = [
    'Status',
    'Ticket',
    'Onderwerp',
    'Datum',
    // "Afdeling",
    '',
  ];

  return (
    <div className="h-full">
      {tickets.length > 0 ? (
        <div className="border-b dark:border-gray-700">
          <Table header={tableHeaders}>
            {tickets.map((ticket: any) => (
              <TableRow
                onClick={() => viewTicket(ticket)}
                key={ticket.id}
                className="cursor-pointer"
              >
                <TableItem>
                  <Tag style={ticket.tic_status} label={ticket.tic_status} />
                </TableItem>
                <TableItem>#{ticket.tic_id}</TableItem>
                <TableItem>
                  <TruncateString text={ticket.tic_onderwerp} limit={30} />
                </TableItem>
                <TableItem>
                  <DateFormatted date={ticket.created_at} />
                </TableItem>
                {/* <TableItem>
                  <Tag style={"cyod"} label={ticket.tic_afdeling} />
                </TableItem> */}
                <TableItem>
                  <button onClick={() => viewTicket(ticket)}>
                    <Eye size={18} />
                  </button>
                </TableItem>
              </TableRow>
            ))}
          </Table>
        </div>
      ) : (
        <div className="h-full flex items-center">
          <Typography type={'default'} tag={'h1'}>
            Geen tickets
          </Typography>
        </div>
      )}
    </div>
  );
};

export default TicketTable;
